<template>
  <div class="faultInfoContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="info">
        <template #title>
          <span>
            <img src="../../assets/svg/faultIcon.svg" alt="" />
            故障信息
          </span>
        </template>
        <el-form :model="form" :rules="formRules" ref="faultForm">
          <el-descriptions :column="3" border>
            <el-descriptions-item label="故障发生日期"
              :labelClassName="this.authStatus ? '' : 'lable-required'"
              :contentClassName="this.authStatus ? '' : 'content-input'"
            >
              <el-form-item prop="happenDate" v-if="!authStatus">
                <el-date-picker
                  :clearable="false"
                  :disabled="authStatus"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  v-model="form.happenDate"
                ></el-date-picker>
              </el-form-item>
              <span v-else>
                {{ form.happenDate }}
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="严重程度" v-bind="authStatus && editStatus ? '' : otherClassName">
              <div v-if="authStatus && editStatus"> {{form.issueSeverity}}</div>
              <el-form-item prop="issueSeverity" v-else>
                <el-select
                  filterable
                  clearable
                  v-model="form.issueSeverity"
                  :disabled="authStatus && editStatus"
                  placeholder="请选择严重程度"
                >
                  <el-option
                    v-for="(item, index) in severityDataKD"
                    :key="index"
                    :label="item.label"
                    :value="item.code"
                  >
                    <el-tooltip placement="right" effect="light">
                      <div
                        slot="content"
                        class="severityTips"
                        v-html="item.desc"
                      ></div>
                      <span>{{ item.label }}</span>
                    </el-tooltip>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="反馈单目的" v-bind="authStatus && editStatus ? '' : otherClassName">
              <div v-if="authStatus && editStatus">
                <div v-for="(item, index) in form.feedbackPurpose" :key="index">
                  <el-tag type="info" v-if="item == 1">质量改进</el-tag>
                  <el-tag type="info" v-if="item == 2">索赔备案</el-tag>
                  <el-tag type="info" v-if="item == 3">紧急补件</el-tag>
                  <el-tag type="info" v-if="item == 4">技术援助</el-tag>
                </div>
              </div>
              <el-form-item prop="feedbackPurpose" v-else>
                <el-select
                  filterable
                  clearable
                  multiple
                  v-model="form.feedbackPurpose"
                  placeholder="请选择反馈单目的"
                  :disabled="authStatus && editStatus"
                >
                  <el-option label="质量改进" value="1" />
                  <el-option label="索赔备案" value="2" />
                  <el-option label="紧急补件" value="3" />
                  <el-option label="技术援助" value="4" />
                </el-select>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item v-if="form.feedbackPurpose && form.feedbackPurpose.includes('3')" label="补件方式" v-bind="authStatus && editStatus ? '' : otherRequiredClassName">
              <div v-if="authStatus && editStatus">
                <div v-for="(item, index) in form.patchMode" :key="index">
                  <el-tag type="info" v-if="item == 1">紧急空运</el-tag>
                  <el-tag type="info" v-if="item == 2">随KD订单发运</el-tag>
                  <el-tag type="info" v-if="item == 3">通过配件订单发运</el-tag>
                </div>
              </div>
              <el-form-item prop="patchMode" v-else>
                <el-select
                  filterable
                  clearable
                  v-model="form.patchMode"
                  placeholder="请选择补件方式"
                  :disabled="authStatus && editStatus"
                >
                  <el-option label="紧急空运" :value="1" />
                  <el-option label="随KD订单发运" :value="2" />
                  <el-option label="通过配件订单发运" :value="3" />
                </el-select>
              </el-form-item>
            </el-descriptions-item>
            <!--          <el-descriptions-item-->
            <!--            label="维修方案"-->
            <!--            label-class-name="lable-required"-->
            <!--            content-class-name="content-input"-->
            <!--          >-->
            <!--            <el-select-->
            <!--              v-model="faultList.repairPlan"-->
            <!--              placeholder="请选择"-->
            <!--              :disabled="authStatus"-->
            <!--            >-->
            <!--              <el-option label="维修" :value="0" />-->
            <!--              <el-option label="更换" :value="1" />-->
            <!--            </el-select>-->
            <!--          </el-descriptions-item>-->
            <!--          <el-descriptions-item-->
            <!--            label="故障类别"-->
            <!--            label-class-name="lable-required"-->
            <!--            content-class-name="content-input"-->
            <!--          >-->
            <!--            <el-select-->
            <!--              v-model="faultList.faultType"-->
            <!--              placeholder="请选择"-->
            <!--              :disabled="authStatus"-->
            <!--            >-->
            <!--              <el-option-->
            <!--                v-for="item in badTypeList[faultList.carAttribute]"-->
            <!--                :key="item.code"-->
            <!--                :label="item.value"-->
            <!--                :value="Number(item.code)"-->
            <!--              >-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <!--          </el-descriptions-item>-->
            <el-descriptions-item
              label="故障来源"
              v-bind="baseClassConfig"
              :content-class-name="
                baseClassConfig.labelClassName == '' ? '' : 'content-input'
              "
            >
              <div v-if="baseClassConfig.labelClassName == 'lable-required'">
                <el-form-item prop="sourceType">
                  <el-radio-group
                    v-model="form.sourceType"
                    :disabled="authStatus"
                  >
                    <el-radio :label="0">制程质量</el-radio>
                    <el-radio :label="1">开箱质量</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-else>{{ form.sourceType == 1 ? "开箱质量" : "制程质量" }}</div>
            </el-descriptions-item>

            <el-descriptions-item
              label="是否重点问题"
              v-bind="baseClassConfig"
              :content-class-name="
                baseClassConfig.labelClassName == '' ? '' : 'content-input'
              "
            >
              <div v-if="baseClassConfig.labelClassName == 'lable-required'">
                <el-form-item prop="importantType">
                  <el-radio-group
                    v-model="form.importantType"
                    :disabled="authStatus"
                  >
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-else>{{ form.importantType == 1 ? "是" : "否" }}</div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions
            :column="3"
            border
            v-if="form.importantType === 1"
          >
            <el-descriptions-item :span="6" v-bind="translateClassName">
              <template slot="label">
                <div class="labelDetail">
                  <p>重点问题描述</p>
                  <div>
                    <translate
                      :content="form.importantDescribe"
                      field="importantDescribeCh"
                      @getTranslateVal="
                        (field, value) => {
                          this.$set(form, field, value);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <div class="translateDetail">
                <el-form-item prop="importantDescribe" v-if="!authStatus">
                  <el-input
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    v-model="form.importantDescribe"
                    :disabled="authStatus"
                    type="textarea"
                    placeholder="请输入重点问题描述"
                  />
                </el-form-item>
                <div v-else class="leftForm problemDesInfo">
                  {{ form.importantDescribe }}
                </div>
                <div class="problemDesInfo">{{ form.importantDescribeCh }}</div>
                <!-- <el-input
                  disabled
                  v-model="form.importantDescribeCh"
                  type="textarea"
                /> -->
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="3" border v-bind="serviceClassName">
            <el-descriptions-item
              label="KD工厂是否有维修措施"
              v-bind="serviceClassName"
            >
              <div v-if="baseClassConfig.labelClassName == 'lable-required'">
                <el-form-item prop="serviceMeasure">
                  <el-radio-group
                    v-model="form.serviceMeasure"
                    :disabled="authStatus"
                  >
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>

              </div>
              <div v-else>
                {{ form.serviceMeasure == 1 ? "是" : "否" }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions
            :column="3"
            border
            v-if="form.serviceMeasure == 1"
          >
            <el-descriptions-item :span="6" v-bind="translateClassName">
              <template slot="label">
                <div class="labelDetail">
                  <p>客户海外KD工厂处置方案</p>
                  <div>
                    <translate
                      :content="form.marketService"
                      field="marketServiceCh"
                      @getTranslateVal="
                        (field, value) => {
                          this.$set(form, field, value);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <div class="translateDetail">
                <el-form-item prop="marketService" v-if="!authStatus">
                  <el-input
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    v-model="form.marketService"
                    :disabled="authStatus"
                    type="textarea"
                    placeholder="请输入客户海外KD工厂处置方案"
                  />
                </el-form-item>
                <div v-else class="leftForm problemDesInfo">
                  {{ form.marketService }}
                </div>
                <div class="problemDesInfo">{{ form.marketServiceCh }}</div>
                <!-- <el-input
                  disabled
                  v-model="form.marketServiceCh"
                  type="textarea"
                /> -->
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="零部件类别">
              <div v-for="(item, index) in componentCategoryList" :key="index">
                <div v-if="item.code == form.componentType">
                  {{ item[componentCategoryName.get("zh")] }}
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="零部件批次信息">{{
              form.componentBatchs
            }}</el-descriptions-item>
            <el-descriptions-item label="订单号">{{
              form.orderNum
            }}</el-descriptions-item>
            <el-descriptions-item label="订单车辆数量" v-bind="authStatus ? '' :baseClassConfig">
              <el-form-item prop="carTotal" v-if="!authStatus">
                <el-input-number
                  :controls="false"
                  :precision="0"
                  :disabled="authStatus"
                  v-model="form.carTotal"
                  placeholder="请输入订单车辆数量"
                >
                </el-input-number>
              </el-form-item>
              <div v-else>{{form.carTotal}}</div>
            </el-descriptions-item>
            <!--          <el-descriptions-item label="故障数量"-->
            <!--            >{{ faultList.faultNumber }}-->
            <!--          </el-descriptions-item>-->
            <!-- <el-descriptions-item
            label="疑似/祸首件名称"
            content-class-name="content-input"
          >
            <el-input
              v-model="faultList.suspectPartName"
              :disabled="authStatus"
              placeholder="请输入疑似/祸首件名称"
            ></el-input>
          </el-descriptions-item> -->
            <!-- <el-descriptions-item
            label="疑似/祸首件代码"
            content-class-name="content-input"
          >
            <el-input
              v-model="faultList.suspectPartNumber"
              :disabled="authStatus"
              placeholder="请输入疑似/祸首件代码"
            ></el-input>
          </el-descriptions-item> -->
            <!-- <el-descriptions-item
            label="供应商名称/代码"
            content-class-name="content-input"
          >
            <el-input
              v-model="faultList.supplierInfo"
              :disabled="authStatus"
              placeholder="请输入供应商名称/代码"
            ></el-input>
          </el-descriptions-item> -->
          </el-descriptions>
          <div>
            <p class="subTitle">故障零件号/物料代码
              <el-button
                type="primary"
                v-if="isKdServiceManager"
                @click="handleAdd"
                style="margin-bottom: 3px"
              >增加故障件</el-button>
            </p>
            <el-table
              ref="tableRef"
              :data="faultList.vinCheckRespList"
              border
              stripe
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
                align="center"
              ></el-table-column>
              <!-- 外包装箱号 -->
              <el-table-column property="outBoxNo" min-width="120px" align="center">
                <template #header>
                  <span>木/铁箱编号</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager && scope.$index > 0">
                    <el-input v-model="scope.row.outBoxNo"  style="width: 100%" size="mini" />
                  </el-form-item>
                  <span v-else>{{ scope.row.outBoxNo }}</span>
                </template>
              </el-table-column>
              <!-- 纸箱号 -->
              <el-table-column property="paperNo" min-width="120px" show-overflow-tooltip align="center">
                <template #header>
                  <span>纸箱编号</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-input v-model="scope.row.paperNo"  style="width: 100%" size="mini" />
                  </el-form-item>
                  <span v-else>{{ scope.row.paperNo }}</span>
                </template>
              </el-table-column>
              <!-- 配件编码 -->
              <el-table-column property="faultCode" min-width="200px" align="center">
                <template #header>
                  <span>零件号/物料代码</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-autocomplete
                      class="table-auto-input"
                      size="mini"
                      :ref="'autocomplete' + scope.$index"
                      v-model="scope.row.faultCode"
                      :fetch-suggestions="getFaultList"
                      @select="handleSelect($event, scope.$index)"
                      @keyup.enter.native="handleInput('autocomplete' + scope.$index)"
                      @blur="onBlurFault(scope.$index)"
                    ></el-autocomplete>
                  </el-form-item>
                  <span v-else>{{ scope.row.faultCode }}</span>
                </template>
              </el-table-column>
              <!-- 配件名称 -->
              <el-table-column property="faultName" min-width="120px" align="center">
                <template #header>
                  <span>配件名称</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-input v-model="scope.row.faultName"  style="width: 100%" size="mini" />
                  </el-form-item>
                  <span v-else>{{ scope.row.faultName }}</span>
                </template>
              </el-table-column>
              <!-- 故障配件数量 -->
              <el-table-column property="faultNumber" min-width="120px" align="center">
                <template #header>
                  <span>故障零件数量</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-input-number class="number-input" :controls="false" :precision="0" v-model="scope.row.faultNumber" style="width: 100%" size="mini"></el-input-number>
                  </el-form-item>
                  <span v-else>{{ scope.row.faultNumber }}</span>
                </template>
              </el-table-column>
              <!-- 发动机号 -->
              <el-table-column
                v-if="faultList.componentType === 1"
                property="engineNo"
                min-width="120px"
                align="center"
              >
                <template #header>
                  <!-- <span
                  v-if="
                    !(disabled && !enableFormItem.includes('vinCheckRespList'))
                  "
                  style="color: #F56C6C"
                  >*</span
                > -->
                  <span>发动机号</span>
                </template>
              </el-table-column>
              <!-- 发动机型号 -->
              <el-table-column
                v-if="faultList.componentType === 1"
                property="engineType"
                min-width="120px"
                align="center"
              >
                <template #header>
                  <!-- <span
                  v-if="
                    !(disabled && !enableFormItem.includes('vinCheckRespList'))
                  "
                  style="color: #F56C6C"
                  >*</span
                > -->
                  <span>发动机型号</span>
                </template>
              </el-table-column>
              <!-- 订单批次号 -->
              <el-table-column property="orderBatch" min-width="120px" align="center">
                <template #header>
                  <span>订单批次号</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-input v-model="scope.row.orderBatch" style="width: 100%" size="mini" />
                  </el-form-item>
                  <span v-else>{{ scope.row.orderBatch }}</span>
                </template>
              </el-table-column>
              <!-- 零部件批次号 -->
              <el-table-column property="partBatchNo" min-width="120px" align="center">
                <template #header>
                  <span>零部件批次号</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-input v-model="scope.row.partBatchNo" style="width: 100%" size="mini" />
                  </el-form-item>
                  <span v-else>{{ scope.row.partBatchNo }}</span>
<!--                  <span>{{ scope.row.partBatchNo }}</span>-->
                </template>
              </el-table-column>
              <!-- 供应商代码 -->
              <el-table-column property="supplierCode" min-width="120px" align="center">
                <template #header>
                  <span>供应商代码</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-input v-model="scope.row.supplierCode" style="width: 100%" size="mini" />
                  </el-form-item>
                  <span v-else>{{ scope.row.supplierCode }}</span>
<!--                  <span>{{ scope.row.supplierCode }}</span>-->
                </template>
              </el-table-column>
              <!-- 故障类别 -->
              <el-table-column property="faultTypeZh" min-width="120px" align="center">
                <template #header>
                  <span>故障类别</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-select filterable clearable v-model="scope.row.faultTypeZh" placeholder="请选择" size="mini" style="width: 100%" @change="setValByLanguage('faultType', scope.row, scope.$index)">
                      <el-option v-for="(item, index) in kdFaultTypeList.filter(item => item.codeText === 'zh')" :key="index" :label="item.value" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <span v-else>{{ scope.row.faultTypeZh }}</span>
                </template>
              </el-table-column>
              <!-- 维修方案 -->
              <el-table-column property="repairPlanZh" min-width="120px" align="center">
                <template #header>
                  <span>维修方案</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                    <el-select filterable clearable v-model="scope.row.repairPlanZh" placeholder="请选择" size="mini" style="width: 100%" @change="setValByLanguage('repairPlan', scope.row, scope.$index)">
                      <el-option v-for="(item, index) in kdRepairPlanList.filter(item => item.codeText === 'zh')" :key="index" :label="item.value" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <span v-else>{{ scope.row.repairPlanZh }}</span>
                </template>
              </el-table-column>
              <!-- 单车用量 -->
<!--              <el-table-column-->
<!--                property="singleDosage"-->
<!--                label="单车用量"-->
<!--                min-width="120px"-->
<!--                align="center"-->
<!--              >-->

                <el-table-column property="singleDosage" min-width="120px" align="center">
                  <template #header>
                    <span>单车用量</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item v-if="isKdServiceManager  && scope.$index > 0">
                      <el-input v-model="scope.row.singleDosage"  placeholder="请输入用量" type="number" style="width: 100%" size="mini" />
                    </el-form-item>
                    <span v-else>{{ scope.row.singleDosage }}</span>
                  </template>
                </el-table-column>
<!--              </el-table-column>-->
              <!-- 到港时间 -->
              <el-table-column property="arrivalTime" min-width="180px" align="center">
                <template #header>
                  <span class="symbolColor">*</span>
                  <span>到港时间</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0"
                                :prop="'vinCheckRespList.' + scope.$index + '.arrivalTime'"
                                :rules="{ required: true, message: '到港时间不能为空' }">
                    <el-date-picker v-model="scope.row.arrivalTime" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择到港时间"></el-date-picker>
                  </el-form-item>
                  <span v-else>{{ scope.row.arrivalTime }}</span>
                </template>
              </el-table-column>

<!--              <el-table-column-->
<!--                property="arrivalTime"-->
<!--                label="到港时间"-->
<!--                min-width="120px"-->
<!--                align="center"-->
<!--              ></el-table-column>-->
              <!-- 开箱时间 -->
<!--              <el-table-column-->
<!--                property="unboxingTime"-->
<!--                label="开箱时间"-->
<!--                min-width="120px"-->
<!--                align="center"-->
<!--              ></el-table-column>-->
              <el-table-column property="unboxingTime" min-width="180px" align="center">
                <template #header>
                  <span class="symbolColor">*</span>
                  <span>开箱时间</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0"
                                :prop="'vinCheckRespList.' + scope.$index + '.unboxingTime'"
                                :rules="{ required: true, message: '开箱时间不能为空' }">
                    <el-date-picker v-model="scope.row.unboxingTime" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择开箱时间"></el-date-picker>
                  </el-form-item>
                  <span v-else>{{ scope.row.unboxingTime }}</span>
                </template>
              </el-table-column>
              <!-- 上线时间 -->
<!--              <el-table-column-->
<!--                property="onlineTime"-->
<!--                label="上线时间"-->
<!--                min-width="120px"-->
<!--                align="center"-->
<!--              ></el-table-column>-->
              <el-table-column property="onlineTime" min-width="180px" align="center">
                <template #header>
                  <span class="symbolColor">*</span>
                  <span>上线时间</span>
                </template>
                <template slot-scope="scope">
                  <el-form-item v-if="isKdServiceManager  && scope.$index > 0"
                                :prop="'vinCheckRespList.' + scope.$index + '.onlineTime'"
                                :rules="{ required: true, message: '上线时间不能为空' }">
                    <el-date-picker v-model="scope.row.onlineTime" type="date" value-format="yyyy-MM-dd"
                                    placeholder="请选择上线时间"></el-date-picker>
                  </el-form-item>
                  <span v-else>{{ scope.row.onlineTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="createTime"
                label="补充时间"
                min-width="150px"
                align="center"
                ></el-table-column>
              <!-- 故障描述 -->
              <!--          <el-table-column-->
              <!--            property="questionContent"-->
              <!--            label="故障描述"-->
              <!--            min-width="120px"-->
              <!--            align="center"-->
              <!--          >-->
              <!-- <template slot-scope="scope">
                <el-form-item
                  v-if="
                    !(disabled && !enableFormItem.includes('vinCheckRespList'))
                  "
                >
                  <el-input
                    v-model="scope.row.questionContent"
                    placeholder="请输入"
                    style="width: 100%"
                    size="mini"
                  />
                </el-form-item>
                <span v-else>
                  {{ scope.row.questionContent }}
                </span>
              </template> -->
              <!--          </el-table-column>-->
              <!-- 操作（仅KD服务经理可见，第一行不可删除） -->
              <el-table-column label="操作" align="center" width="120px" fixed="right" v-if="isKdServiceManager">
                <template slot-scope="scope">
                  <el-button v-if="scope.$index > 0" size="mini" type="text" @click="handleDelete(scope.row, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import Translate from "@/components/translate";
import componentConfig from "@/mixins/componentConfig";
import { getCurrentRoles, hasAnyRole } from "@/utils/role";
import {getDictItem} from "@/util/dict";
export default {
  name: "faultInfo",
  components: { Translate },
  mixins: [componentConfig],
  data() {
    return {
      kdFaultTypeList: [], // 故障类型列表
      kdRepairPlanList: [], // 维修方案列表
      activeNames: ["info"], // 全部展开
      // badTypeList: { 0: [], 1: [] }, // 故障类型列表 0-燃油车,1-电动车
      form: {},
      editStatus: true,
    };
  },
  props: {
    faultList: {
      type: [Array, Object],
      //   default:() => []
    },
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    isKdServiceManager() {
      return hasAnyRole(['KD服务经理']) && this.form.status == 1;
    },
    // 是否显示必填*
    baseClassConfig() {
      return {
        labelClassName: this.authStatus ? "" : "lable-required",
        contentClassName: "content-input",
      };
    },
    // 严重程度必填状态
    otherClassName() {
      return {
        labelClassName:
          this.authStatus && this.editStatus ? "" : "lable-required",
        contentClassName: "content-input",
      };
    },
    // 严重程度必填状态
    otherRequiredClassName() {
      return {
        contentClassName: "content-input",
      };
    },
    // 翻译
    translateClassName() {
      return {
        labelClassName: `translate-label ${this.baseClassConfig.labelClassName}`,
        contentClassName: "translate-content",
      };
    },
    // 维修措施
    serviceClassName() {
      return {
        labelClassName: `${this.baseClassConfig.labelClassName} ${
          this.faultList.serviceMeasure == 0 ? " bottom-none" : ""
        } ${this.faultList.importantType == 0 ? " top-none" : ""}`,
        contentClassName: `${
          this.baseClassConfig.labelClassName == "lable-required"
            ? this.baseClassConfig.contentClassName
            : ""
        } ${this.faultList.serviceMeasure == 0 ? " bottom-none" : ""} ${
          this.faultList.importantType == 0 ? " top-none" : ""
        }`,
      };
    },
    formRules() {
      const isRequired = !this.authStatus;
      const otherRequired = !(this.authStatus && this.editStatus);
      // 公共规则配置
      const commonRule = {
        required: isRequired,
        trigger: ["change", "blur"],
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      return {
        happenDate: createRule("故障发生日期"),
        issueSeverity: [{ required: otherRequired, message: "严重程度不能为空", trigger: ["change", "blur"] }],
        feedbackPurpose: [{ required: otherRequired, message: "反馈单目的不能为空", trigger: ["change", "blur"] }],
        // patchMode: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (Array.isArray(this.form.feedbackPurpose) && this.form.feedbackPurpose.includes('3') && !value) {
        //         callback(new Error("补件方式不能为空"));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        importantType: createRule("是否重点问题"),
        sourceType:  [{ required: otherRequired, message: "故障来源不能为空", trigger: ["change", "blur"] }],
        importantDescribe: createRule("重点问题描述"),
        serviceMeasure: createRule("是否有维修措施"),
        marketService: createRule("客户海外KD工厂处置方案"),
        carTotal: createRule("订单车辆数量"),

      };
    },
  },
  async created() {
    // this.getBadTypeList();
    this.getTypeList();
    this.getFaultInfo();
    this.getAuditStatus();
    await this.getkdFaultTypeList();
    await this.getkdRepairPlanList();
  },
  methods: {
    // 获取车型列表
    async getkdFaultTypeList() {
      const res = await getDictItem("kdFaultType");
      this.kdFaultTypeList = res || [];
    },
    // 获取维修方案
    async getkdRepairPlanList() {
      const res = await getDictItem("kdRepairPlan");
      this.kdRepairPlanList = res || [];
    },
    // 技术经理和质量经理
    getAuditStatus() {
      const userRoles = getCurrentRoles();
      const { userTaskId, taskStatus } = this.faultList;
      const rolePermissions = {
        KD技术经理: ["Activity_0cimoly", "Activity_1ayglqh"],
        KD质量经理: ["Activity_1jmu1ad"],
      };
      this.editStatus =
        taskStatus !== 0 ||
        !userRoles.some((r) => rolePermissions[r]?.includes(userTaskId));
    },
    // 获取数据
    getFaultInfo() {
      if (this.faultList) {
        this.form = this.faultList;
        if (typeof this.form.feedbackPurpose === 'string') {
          this.form.feedbackPurpose = this.form.feedbackPurpose.split(",");
        }
        if (this.form.sourceType == undefined || this.form.sourceType === null){
          this.form.sourceType = 0;
        }
      }
    },
    validateForm() {
      return this.$refs["faultForm"].validate()
        .then(() => ({ isValid: true, object: null }))
        .catch(errors => ({ isValid: false, object: errors }));
    },
    // 增加故障件
    handleAdd() {
      if (!this.faultList.vinCheckRespList) {
        this.$set(this.faultList, 'vinCheckRespList', []);
      }
      this.faultList.vinCheckRespList.push({
        outBoxNo: "",
        paperNo: "",
        faultCode: "",
        faultName: "",
        orderBatch: "",
        faultNumber: 1,
        faultType: "",
        repairPlan: "",
        faultTypeZh: "",
        repairPlanZh: "",
        singleDosage: undefined
      });
    },
    // 删除故障件
    handleDelete(row, index) {
      this.faultList.vinCheckRespList.splice(index, 1);
    }
    // 获取故障类别列表
    // async getBadTypeList() {
    //   this.badTypeList[0] = await getDictItem("badTypeList0");
    //   this.badTypeList[1] = await getDictItem("badTypeList1");
    // },
  },
};
</script>
